import { render, staticRenderFns } from "./ArgInputLedgerRange.vue?vue&type=template&id=0b4e0796"
import script from "./ArgInputLedgerRange.vue?vue&type=script&lang=ts"
export * from "./ArgInputLedgerRange.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports